/**
 * Баннер рулетки — до покупки: на главной и над тарифами.
 *
 * Человек должен знать о рулетке, пока выбирает срок: «+12 вращений»
 * у года — довод в пользу длинной оплаты. Нажатие — экран рулетки с
 * правилами (вращений может ещё не быть).
 */
import { useNavigate } from 'react-router';

import styles from './WheelBanner.module.css';

export function WheelBanner({ spins }: { spins?: number }) {
  const navigate = useNavigate();
  return (
    <button type="button" className={styles.banner} onClick={() => void navigate('/wheel')}>
      <span className={styles.wheel} aria-hidden>
        <span className={styles.hub} />
      </span>
      <span className={styles.body}>
        <span className={styles.title}>
          {spins ? `У вас ${spins} — крутите рулетку` : 'Рулетка за каждую оплату'}
        </span>
        <span className={styles.text}>Скидки, месяцы в подарок и iPhone 18 Pro Max</span>
        <span className={styles.rule}>1 месяц = 1 вращение · 1 год = 12</span>
      </span>
    </button>
  );
}
